import ng from 'angular';

export class MoleculePanelEditRowHeadlineController implements ng.IController {}

export class MoleculePanelEditRowHeadlineComponent implements ng.IComponentOptions {
    public transclude = true;
    public controller = MoleculePanelEditRowHeadlineController;
    public template = require('./panel-edit-row-headline.html');
}
